module.exports = __webpack_public_path__ + "static/media/logo.611d0a84.svg";